export const EnemyTypeIds = (function () {
    return {
        RUSHER: 1,
        SHOOTER: 2,
        BLASTER: 3,
        TANK: 4,
        CORE: 5,
    } as const;
})();